import add from 'date-fns/add';
import format from 'date-fns/format';
import formatISO from 'date-fns/formatISO';
import formatRelative from 'date-fns/formatRelative';
import fromUnixTime from 'date-fns/fromUnixTime';
import isWithinInterval from 'date-fns/isWithinInterval'

import parseISO from 'date-fns/parseISO';

import { CronExpressionParser } from 'cron-parser';

import addDays from 'date-fns/addDays';
import addHours from 'date-fns/addHours';
import addMilliseconds from 'date-fns/addMilliseconds';
import addMinutes from 'date-fns/addMinutes';
import addMonths from 'date-fns/addMonths';
import addSeconds from 'date-fns/addSeconds';
import addWeeks from 'date-fns/addWeeks';
import addYears from 'date-fns/addYears';

import isNil from 'lodash/isNil';

export const newFunction = () => {}

export const nthNumber = (val) => {
  if (val > 3 && val < 21) return `${val}th`;
  switch (val % 10) {
  case 1:
    return `${val}st`;
  case 2:
    return `${val}nd`;
  case 3:
    return `${val}rd`;
  default:
    return `${val}th`;
  }
};

export const isDateBetweenDates = (targetDate, startDate, endDate) => {
  return isWithinInterval(targetDate, { start: startDate, end: endDate })
};


export const formatISOAsRelative = isoDate => formatRelative(parseISO(isoDate), new Date())

export const formatAssayDetailsDate = dateStr => format(parseISO(dateStr), 'MMM d yyyy')

export const formatAssayDetailsDatetime = dateStr => format(parseISO(dateStr), 'MMM d yyyy k:mm:ss')

// TODO - Refactor formatOrchestrationRunDate and formatUserLastLoginDate
export const formatDateWithTimeSeparator = (dateStr, separator = ', ', error = 'Error calculating date.') => {
  if (!dateStr?.length || dateStr === 'error') {
    return error;
  }
  const parsedIso = parseISO(dateStr);
  const formattedDate = format(parsedIso, 'MMM d yyyy')
  const formattedTime = format(parsedIso, 'h:mm:ss aaa')

  return `${formattedDate}${separator}${formattedTime}`;
}

export const formatOrchestrationRunDate = (dateStr) => {
  if (!dateStr?.length || dateStr === 'error') {
    return 'Error calculating run date.';
  }
  const parsedIso = parseISO(dateStr);
  const formattedDate = format(parsedIso, 'MMM d yyyy')
  const formattedTime = format(parsedIso, 'h:mm:ss aaa')

  return `${formattedDate} at ${formattedTime}`;
}

export const formatUserLastLoginDate = (dateStr) => {
  if (!dateStr?.length || dateStr === 'error') {
    return 'Error calculating login time.';
  }
  const parsedIso = parseISO(dateStr);
  const formattedDate = format(parsedIso, 'MMM d yyyy')
  const formattedTime = format(parsedIso, 'h:mm:ss aaa')

  return `${formattedDate}, ${formattedTime}`;
}

export const formatLastRefreshDate = dateObj => format(dateObj, 'MMM d yyy h:mm:ss')

export const formatChartDate = labelFormatString => unixTimestamp => format(fromUnixTime(unixTimestamp), labelFormatString)

export const formatCSVDate = (unixTimestamp) => {
  if (isNil(unixTimestamp)) {
    return unixTimestamp;
  }
  return formatISO(fromUnixTime(unixTimestamp)).split('T').join(' ');
}

export const formatAssayPointDate = assayDate => formatISO(assayDate);

export const formatChartPointDate = pointDate => format(pointDate, "LLL d '\n' k:mm:ss.SS")

export const getTimeRange = (selectedTimeRange = {}) => {
  const timeRangeType = selectedTimeRange?.type;
  if (timeRangeType === 'custom') {
    return [selectedTimeRange.fromDate, selectedTimeRange.toDate];
  }
  if (selectedTimeRange.duration) {
    return [add(new Date(), selectedTimeRange.duration), new Date()];
  }
  // FIXME - This is currently spamming console errors because we don't have logic for this case yet
  // Figure out what the appropriate value would be here - technically isn't needed
  if (timeRangeType !== 'All time') {
    console.error('Unrecognized time range type', selectedTimeRange.type);
  }
  return [add(new Date(), { hours: -1 }), new Date()];
}

export const getEndDateFromDurationAndStart = (startDate, durationStr) => {
  const parts = durationStr.split(' ');
  const duration = parseInt(parts[0], 10);
  const units = parts[1].toLowerCase();

  if (units.includes('millisecond')) {
    return addMilliseconds(startDate, duration);
  }
  if (units === 'seconds' || units === 'second') {
    return addSeconds(startDate, duration);
  }
  if (units.includes('minute')) {
    return addMinutes(startDate, duration);
  }
  if (units.includes('hour')) {
    return addHours(startDate, duration);
  }
  if (units.includes('day')) {
    return addDays(startDate, duration);
  }
  if (units.includes('week')) {
    return addWeeks(startDate, duration);
  }
  if (units.includes('month')) {
    return addMonths(startDate, duration);
  }
  if (units.includes('year')) {
    return addYears(startDate, duration);
  }

  // Should not reach this point
  return null;
}

// Test that it can reliably change timezones for different types of values
// UTC and Not UTC inputs need to be tested for the startDate value
// Different schedule strings as well (daily at midnight, daily at a specific time, every 5 minutes)
export const getNextRunFromCronString = (cronSchedule = '', startDate = new Date(), currentDate = new Date()) => {
  try {
    const parsedSchedule = CronExpressionParser.parse(`${cronSchedule}`, {
      startDate,
      currentDate,
      tz: 'UTC',
    });

    return parsedSchedule.next().toISOString();
  } catch (e) {
    return 'error'
  }
}
